export default __webpack_public_path__ + "a32b13256604562bc4a6fca56847f6f7.svg";